module.exports = "https://cdn-shared.mathletics.com/teacher-modules/student-reports/28/assets/images/b1ffc12c999ac125829cdb71004218b0.png";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/student-reports/certificates/new_certificates/diamond.png
// module id = Evsd
// module chunks = 0